<script lang="ts">
  /**
   * Encryption-status lock indicator (Phase 5 — SCAFFOLDING).
   *
   * Shows whether the OTHER side (the classroom device / all viewers) is
   * viewing an ENCRYPTED stream. Since E2EE is OFF today this is driven by a
   * benign, inert signal and renders the "unencrypted" state. The data path
   * (`encrypted`) is wired so a later phase can populate it per-participant.
   *
   *   encrypted = true   → green CLOSED lock ("all encrypted")
   *   encrypted = false  → yellow OPEN lock ("not encrypted")
   *   encrypted = "some" → amber OPEN lock ("some encrypted")
   */
  import Icon from "./Icon.svelte";
  import { t } from "./i18n";

  /** Inert today: false ("unencrypted") | true ("encrypted") | "some". */
  export let encrypted: boolean | "some" = false;
  /** Hide entirely (e.g. when the feature flag is off). */
  export let visible = true;

  $: closed = encrypted === true;
  $: label =
    encrypted === true
      ? t("e2ee.status.encrypted")
      : encrypted === "some"
        ? t("e2ee.status.partial")
        : t("e2ee.status.unencrypted");
  $: cls =
    encrypted === true ? "enc" : encrypted === "some" ? "partial" : "plain";
</script>

{#if visible}
  <span class="e2ee-lock {cls}" title={label} aria-label={label} role="img">
    <Icon name="lock" on={closed} />
  </span>
{/if}

<style>
  .e2ee-lock {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
  .e2ee-lock.enc {
    color: #2ecc71;
  }
  .e2ee-lock.partial {
    color: #e0a800;
  }
  .e2ee-lock.plain {
    color: #d6b400;
    opacity: 0.85;
  }
</style>
